import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './counter.module.scss';

const METADATA = Metadata.define({
  description: 'Notification counter badge indicator.',
  name: 'Counter Notification Badge',
});

export default class SpdsIndicatorBadgeCounterNotification extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-indicator-badge-counter';
  variantClass = 'spds-indicator-badge-counter-notification';
  variantStyles = styles;
}

export const BADGE_COUNTER_NOTIFICATION_METADATA = SpdsIndicatorBadgeCounterNotification.metadata;
